export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abrir disputa"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un moderador se unirá para ayudar. Por favor, seleccione un motivo y adjunte pruebas."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar al moderador"])}
}